/**
 * @fileoverview Searchable List - blah
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.ui.SearchableList');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const notify = goog.require('yext.notify');
const searchableList = goog.require('yext.storm.common.searchableList');
const templates = goog.require('yext.templates');

/**
 * @param {!jQuery} $list
 * @constructor
 */
const SearchableList = function(options) {
  /** @type {!Object} */
  this.options = options || {
    target: null,
    findAnItemText: null,
    allItemsText: null,
    showAddLink: null,
    showDropdown: null,
    url: null,
    formatItem: null,
    selectionDisabled: false,
  };

  /** @type {!jQuery} */
  this.$ctxt = $(this.options.target || '.js-searchablelist-wrapper');

  /** @type {!jQuery} */
  this.$list = $(templates.render(
    searchableList.list,
    {
      'dropdownRename': yext.msg('Rename'),
      'dropdownDelete': yext.msg('Delete'),
      'placeholder': this.options.findAnItemText,
    }));

  /** @type {string} */
  this.currentStr = '';

  /** @type {!Object<?, ?>} */
  this.dict = {};

  /** @type {number} */
  this.currentSelectedId = 0;
};

/**
 * Initialize the dictionary for the searchable list instance
 *
 * @return {this}
 */
SearchableList.prototype.init = function() {
  this.$ctxt.append(this.$list);
  this.$ctxt.append(templates.render(
    searchableList.dropdown,
    {
      dropdownRename: yext.msg('Rename'),
      dropdownDelete: yext.msg('Delete'),
    }));

  this.load(function(data) {
    this.populateList(data);
    this.bindActions();
    $(this).trigger('ready');
  }.bind(this));

  return this;
};

/** Initialize dictionary */
SearchableList.prototype.initDict = function() {
  var $clone = this.$list.clone(true);
  $clone.find('.selected').removeClass('selected');
  this.dict = {};
  this.dict[''] = $clone.find('.scrollable-list li');
};

/** Update searchableList */
SearchableList.prototype.update = function() {
  this.load(function(data) {
    this.populateList(data);
    $(this).trigger('load.searchableList');
  }.bind(this));
};

/**
 * Loads the initial set of items that are contained in the list
 * @param {function()} onLoad anon call back function that populates the list and finishes init
 */
SearchableList.prototype.load = function(onLoad) {
  $.ajax({
    url: this.options.url,
    data: this.options.ajaxParams,
  })
    .done(onLoad)
    .fail(function(xhr) {
      var message = yext.msg(
        'There was a problem connecting to the server. ' +
      'Please <a href="{0}">reload</a> or try again.',
        document.location.href);
      if (xhr.responseJSON && yext.isString(xhr.responseJSON.error)) {
        message = xhr.responseJSON.error;
      }
      notify.showError(message);
    });
};

/**
 * Callback that takes the ajax response and populates the list
 * Each item must have a name and id (count is optional)
 * @param {!Object} data response from the ajax request
 */
SearchableList.prototype.populateList = function(data) {
  if (this.options.hideWhenEmpty) {
    this.$ctxt.show();
  }

  if (this.options.emptyMessageClass) {
    this.$ctxt.find(this.options.emptyMessageClass).toggle(data.items.length == 0);
  }

  if (this.options.hideWhenEmpty && data.items.length === 0) {
    this.$ctxt.hide();
    return;
  }

  var $scrollableList = this.$list.find('.js-scrollable-list');
  $scrollableList.empty();
  if (this.options.allItemsText) {
    $scrollableList.append(this.populateRow({
      id: 0,
      name: this.options.allItemsText,
      count: this.options.totalCount || null,
      showDropdown: false,
      additionalClass: 'js-default-selection selected',
    }));
  }

  if (!Array.isArray(data.items)) {
    notify.showError(yext.msg(
      'There was an error with data from the server. ' +
      'Please <a href="{0}">reload</a> to try again.',
      document.location.href));
    return;
  }

  $.each(data.items, function(index, item) {
    if (item.count == null) {
      if (item.id.value !== undefined) {
        item.count = data.count[item.id.value];
      } else {
        item.count = data.count[item.id];
      }
      if (item.count == null) {
        item.count = 0;
      }
    }
    item.showDropdown = this.options.showDropdown || false;
    $scrollableList.append(this.populateRow(item));
  }.bind(this));

  this.initDict();
};

/**
 * Creates a new row with the given data attributes
 * @param {!Object} item that contains the label information
 */
SearchableList.prototype.populateRow = function(item) {
  var $row = $(templates.render(
    searchableList.listItem,
    item));
  if (this.options.formatItem) {
    this.options.formatItem(item, $row);
  }
  return $row;
};

/** Remove active class from dropdown icons */
SearchableList.prototype.removeActiveClass = function() {
  this.$list.find('button.active').removeClass('active');
};

/**
 * Binds all the controls for the searchable list.
 * Triggers various searchable.{event} events for subscribers
 * @param {boolean} showDropdown flag for if the options dropdown should be displayed
 */
SearchableList.prototype.bindActions = function() {
  if (this.options.showDropdown) {
    this.bindDropdown();
  }
  if (!this.options.selectionDisabled) {
    this.bindSelect();
  }
  this.bindSearch();
};

SearchableList.prototype.bindDropdown = function() {
  var $optionsDropdown = this.$ctxt.find('#searchablelist-options-dropdown');
  var $scrollableList = this.$list.find('.scrollable-list');

  $optionsDropdown.hide();
  this.removeActiveClass();

  /**
   * Click handler for the options drop down that is visible on hover over each li element
   * On click, the options are shown that are applicable to the list
   */
  this.$ctxt.on('click', '#searchablelist-options-dropdown li', function(e) {
    e.stopPropagation();
    var optionSelected = $(e.target).data('option');
    $optionsDropdown.hide();

    var $selectedLi = this.$list.find('.js-searchable-list-item').has('button.active');
    this.$list.trigger(optionSelected + '.searchableList', {
      id: $selectedLi.data('typeid'),
      name: $selectedLi.data('text'),
      count: $selectedLi.data('count'),
    });
  }.bind(this));

  this.$list.on('click', '.js-dropdown-icon', function(e) {
    e.stopPropagation();
    var $arrowClicked = $(e.target);
    var isActive = $arrowClicked.hasClass('active');

    $arrowClicked.toggleClass('active', !isActive);
    $optionsDropdown.toggle(!isActive);

    // Absolutely position the dropdown just below the arrow clicked
    if (!isActive) {
      $optionsDropdown
        .css('z-index', 2000) // It was set this high on the location page ....
        .show()
        .position({
          'of': $arrowClicked,
          'my': 'right top',
          'at': 'right bottom',
        });
      $optionsDropdown.focus();
    }
  });

  /**
   * Since we are now absolutely positioning the dropdown - hide if the users starts scrolling
   * through the list
   */
  $scrollableList.on('scroll', function() {
    $optionsDropdown.hide();
    this.removeActiveClass();
  }.bind(this));

  // Hide options dropdown on clicking in document.
  $(document).off('.hideOptions');
  $(document).on('click.hideOptions', function() {
    $optionsDropdown.hide();
    this.removeActiveClass();
  }.bind(this));
};

/**
 * Click handler for when an item is selected from the searchable lists
 * On click,
 * a) any visible options drop downs are hidden
 * b) the selected class is added to the li element
 * c) the selected class is removed from previously selected elements
 * d) a searchable.selected event is triggered
 */
SearchableList.prototype.bindSelect = function() {
  var $optionsDropdown = this.$ctxt.find('#searchablelist-options-dropdown');
  var $scrollableList = this.$list.find('.scrollable-list');

  this.$list.on('click', '.js-searchable-list-item', function(e) {
    e.stopPropagation();
    var $selectedLi = $(e.target).closest('.js-searchable-list-item');
    this.currentSelectedId = $selectedLi.data('typeid');
    $scrollableList.find('.selected').removeClass('selected');
    $selectedLi.addClass('selected');
    $optionsDropdown.find('.selected').removeClass('selected');
    if (!$(e.target).hasClass('js-dropdown-icon')) {
      $optionsDropdown.hide();
      this.removeActiveClass();
    }

    this.$list.trigger('selected.searchableList', {
      id: $selectedLi.data('typeid'),
      name: $selectedLi.data('text'),
    });
  }.bind(this));
};

/**
 * Function that filters the list based on the text entered in the search box.
 */
SearchableList.prototype.bindSearch = function() {
  // Clear the label filter input when user clicks right-hand X
  this.$list.on('click', '.js-searcher-icon', function() {
    this.$list.find('.js-searchable-list-input').val('').trigger('input');
  }.bind(this));

  var $scrollableList = this.$list.find('.scrollable-list');
  $('.js-searchable-list-input').inputchange(function(e) {
    var currentStr = $(e.target).val().trim().toLowerCase();
    var $newList;
    if (this.currentStr == currentStr) {
      return;
    }
    this.currentStr = currentStr;

    if (!this.dict[currentStr]) {
      var $startingList;
      for (var i=1; i<=currentStr.length; i++) {
        if (this.dict[currentStr.substring(i)]) {
          $startingList = this.dict[currentStr.substring(i)];
        } else if (this.dict[currentStr.substr(0, currentStr.length-i)]) {
          $startingList = this.dict[currentStr.substr(0, currentStr.length-i)];
        }

        if ($startingList) {
          $newList = $startingList.clone(true);
          for (var j=$newList.length-1; j>=0; j--) {
            if (!this.matches($newList.eq(j), currentStr)) {
              $newList.splice(j, 1);
            }
          }
          this.dict[currentStr] = $newList;
          i = currentStr.length;
        }
      }
    }

    $newList = this.dict[currentStr];
    $newList.each(function(ind, el) {
      var $currentItem = $(el);
      $currentItem.toggleClass('selected', this.currentSelectedId === $currentItem.data('typeid'));
    }.bind(this));
    $scrollableList.find('.js-searchable-list-item').detach();
    $scrollableList.html($newList);

    this.$list
      .find('.js-searcher-icon')
      .toggleClass('x-icon', currentStr.length > 0);
  }.bind(this));
};

/**
 * Selects list item with the given id
 *
 * @param {string} id
 */
SearchableList.prototype.select = function(id) {
  this.$list.find('.selected').removeClass('selected');
  this.$list.find('.js-searchable-list-item[data-typeid="' + id + '"]').addClass('selected');
};

/**
 * Selects list item tagged as the default selection
 */
SearchableList.prototype.selectDefault = function() {
  // This may not be the best solution but it is by far the easiest given the current state
  // of the code.
  this.$list.find('.js-searchable-list-item.js-default-selection').trigger('click');
};

/**
 * Returns a boolean if the query string is a substring of the $li's string content
 * @param {!jQuery, string}
 * @return {}
 */
SearchableList.prototype.matches = function($li, queryString) {
  var liString = $li.data('text').toString().toLowerCase();
  return liString.indexOf(queryString) !== -1;
};

exports = SearchableList;
